<template>
  <div class="col-12 timeline-container">
    <div id="timeline-wrapper" class="timeline-wrapper">
      <div class="ni-h-timeline align-right show-date mb-4">
        <span class="line"></span>
        <div class="timeline-box">
          <div class="box-items">
            <Comment class="comment" v-for="cm in comments" :key="cm.uuid"
                          :comment="cm" :outgoing="cm.user_uuid === userUuid"/>
          </div>
        </div>
      </div><!-- .ni-h-timeline -->
    </div>
    <EmojiArea ref="textbox" />

    <div class="d-flex">
      <MiniToolbar class="p-2 mr-auto" :buttons="discussionToolbar" @clicked="toolbarClicked"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Comment from '@/components/Comment.vue'
import EmojiArea from '@/components/EmojiArea.vue'
import MiniToolbar from '@/components/MiniToolbar.vue'

export default {
  components: {
    Comment,
    EmojiArea,
    MiniToolbar
  },
  props: {
    comments: Array
  },
  methods: {
    toolbarClicked: function (id, button) {
      switch (button.icon) {
        case 'sli-chemistry':
          this.$emit('drugsTable')
          break
        case 'sli-paper-plane':
          this.$emit('send', this.$refs.textbox.text())
          this.$refs.textbox.clearText()
          break
      }
    },
    scrollToBottom () {
      setTimeout(() => {
        var timelineWrapper = document.getElementById('timeline-wrapper')
        timelineWrapper.scrollTop = timelineWrapper.scrollHeight
      }, 100)
    }
  },
  computed: {
    ...mapGetters({
      userUuid: 'account/userUuid'
    })
  },
  data: () => ({
    discussionToolbar: [
      {
        icon: 'sli-chemistry',
        id: 'discussion-drug-table',
        tip: 'discussion.drugs_table',
        small: true
      },
      {
        icon: 'sli-paper-plane',
        id: 'discussion-send',
        tip: 'discussion.send_msg'
      }
    ]
  }),
  mounted () {
  }
}
</script>

<style>
.timeline-container {
  /* fix margin on display flex container */
  padding-bottom: 1em;
  text-align: left;
  padding: 0;
}
.timeline-wrapper {
  width: 100%;
  max-height: 300px;
  overflow-x: hidden;
  overflow-y: auto;
}
.send-btn {
  color: var(--clr3);
}
</style>



// WEBPACK FOOTER //
// src/views/Discussion.vue